module.exports = __webpack_public_path__ + "img/eazis-pulse-black.6a92a352.png";